module.exports = __webpack_public_path__ + "img/zixun-3.b190bfe.png";